import React, { useContext } from "react";
import { CasesContext } from "../CasesContext";
import { caseStages } from "../config";
import "./CasesTabs.scss";
import Dot from "../NotificationDot";

const CasesTabs = (props) => {
  const { navCounts } = props;
  const { activeTab, activeNav, setActiveTab, setLocalActiveTab, setFilterBy } =
    useContext(CasesContext);
  const tabCounts = navCounts[`Form${activeNav.machine_name}`];
  const handleKeyDown = (e, stage) => {
    if (e.which === 32) {
      setActiveTab(stage);
      setFilterBy({});
      setLocalActiveTab(stage);
      e.preventDefault();
    }
  };
  return (
    <div className="grid-row cases-tabs">
      <div className="navigation tablet:grid-col-12">
        {caseStages.map((stage, index) => {
          return typeof tabCounts[stage.machine_name] !== "undefined" ? (
            <a
              tabindex={index + Object.keys(navCounts).length}
              key={index}
              onClick={() => {
                setActiveTab(stage);
                setFilterBy({});
                setLocalActiveTab(stage);
              }}
              onKeyDown={(e) => handleKeyDown(e, stage)}
              className={
                stage.machine_name === activeTab.machine_name
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              {tabCounts[stage.machine_name]?.["hasActiveNotification"] && (
                <Dot text={stage.ui_name} />
              )}
              <span style={{ marginLeft: 4 }}>{stage.ui_name}</span>(
              {tabCounts[stage.machine_name]?.["Total"] ?? 0})
            </a>
          ) : (
            ""
          );
        })}
      </div>
    </div>
  );
};
export default CasesTabs;
